<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script lang="ts">
import type { DropdownMenuSubContentEmits, DropdownMenuSubContentProps } from 'reka-ui'

import '../item.css'
import '../menu.css'

export interface DropdownSubmenuProps extends DropdownMenuSubContentProps {}

export type DropdownSubmenuEmits = DropdownMenuSubContentEmits

type DropdownSubmenuSlots = {
  default(props: {}): unknown
  right(props: {}): unknown
  icon?(props: {}): unknown
  items(props: {}): unknown
}
</script>

<script setup lang="ts">
import { DropdownMenuPortal, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger } from 'reka-ui'

import { useForwardPropsEmitsSkip } from '@/composables/utils/useForwardPropsEmitsSkip.ts'

import ChevronRight from '~mingcute/arrow/right_line.svg'

const open = defineModel<boolean>('open')
const props = defineProps<DropdownSubmenuProps>()
const emit = defineEmits<DropdownSubmenuEmits>()
const slots = defineSlots<DropdownSubmenuSlots>()
const forwarded = useForwardPropsEmitsSkip(props, emit, [], ['open'])
</script>

<template>
  <DropdownMenuSub v-model:open="open">
    <DropdownMenuSubTrigger class="flopui-menu-item">
      <div v-if="slots.icon" class="flopui-menu-item-icon" aria-hidden="true">
        <slot name="icon" />
      </div>
      <div class="flopui-menu-item-contents">
        <slot />
      </div>
      <div class="flopui-menu-item-right">
        <slot name="right" />
        <ChevronRight aria-hidden="true" class="flopui-menu-item-more" />
      </div>
    </DropdownMenuSubTrigger>
    <DropdownMenuPortal>
      <DropdownMenuSubContent
        v-bind="forwarded"
        class="flopui-menu-submenu flopui-menu-content"
        :side-offset="2"
        :align-offset="-5"
        :collision-padding="8"
      >
        <div class="flopui-menu-viewport">
          <slot name="items" />
        </div>
      </DropdownMenuSubContent>
    </DropdownMenuPortal>
  </DropdownMenuSub>
</template>
